import { Component } from 'react';
import { captureException } from '../../utils/captureException';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
    captureException(error, ['Error boundary'], {
      extra: {
        errorInfo
      }
    });
  }
  render() {
    const {
      error
    } = this.state;
    if (error) {
      return null;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;